import React, { type FC } from 'react';

export const BoltSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path d="M3.33203 8.66927L10.332 2.33594L8.9987 7.33594H12.6654L5.66536 13.6693L6.9987 8.66927H3.33203Z" />
        </svg>
    );
};
